import React from 'react';
import * as Styled from './LabeledSelect.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A generic styled labeled select component with some preconfigured nicety options.
 */
export const LabeledSelect = ({
  label,
  value = '',
  options,
  optionDisplayStrings,
  onChange,
  onBlur,
  shouldShowErrorState = false,
  placeholderOptionText,
  ...rest
}) => /*#__PURE__*/_jsxs(Styled.Label, {
  children: [/*#__PURE__*/_jsx("span", {
    children: label
  }), /*#__PURE__*/_jsxs(Styled.Select, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    shouldShowErrorState: shouldShowErrorState,
    ...rest,
    children: [placeholderOptionText && /*#__PURE__*/_jsx("option", {
      value: "",
      children: placeholderOptionText
    }), options.map(option => /*#__PURE__*/_jsx("option", {
      value: option,
      children: optionDisplayStrings ? optionDisplayStrings[option] : option
    }, option))]
  })]
});